import Tree from './tree'

export default Tree



// WEBPACK FOOTER //
// ./src/components/tree/index.js